import getDependencies from './getDependencies';
import basicFeed from './basicFeed';
import uniq from '../../utils/uniq';

export function addData(data, type, state) {
  if (data.isTemporary) {
    return;
  }

  const { feedsToUpdate, dataFeeds } = getDependencies(data, type);

  dataFeeds.forEach(id => state[id] = state[id] || basicFeed);

  feedsToUpdate.forEach(id => {
    const feed = state[id] || basicFeed;

    const updateItems = { items: uniq([data.id, ...(feed.didInvalidate ? [] : feed.items)]) };

    state[id] = {
      ...feed,
      didInvalidate: false,
      ...updateItems,
    };
  });
}

export default (dataToCreate, oldState) => {
  if (!dataToCreate) {
    return oldState;
  }

  const state = { ...oldState };
  Object.entries(dataToCreate)
    .forEach(
      ([type, datas]) => Object.values(datas).forEach(
        data => addData(data, type, state)
      )
    );

  return state;
};



// WEBPACK FOOTER //
// ./~/virgo/src/reducers/feeds/add.js